'use strict';

import ngResource from 'angular-resource';

function DailyActivePowerService($resource) {
    return $resource(
        '/api/daily_active_power/:id', { id: '@id' },
        {
            show: { method: 'GET', isArray: false }
        }
    )
}

export default angular.module('leptonApp.DailyActivePowerService', ['ngResource'])
    .factory('DailyActivePowerService', ['$resource', DailyActivePowerService])
    .name;



// WEBPACK FOOTER //
// ./public/dev/components/api/daily_active_power/daily_active_power.service.js